<aside
  class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 SubMenu"
  id="SubMenu"
>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    style="top: 70px; padding-left: 0px; padding-right: 0px;height: 90vh !important;overflow-y: auto;"
    *ngIf="Admin"
  >
    <mat-accordion class="example-headers-align">
      <mat-expansion-panel hideToggle [expanded]="step === 10">
        <mat-expansion-panel-header>
          <mat-panel-title> 3PLFreightSoftware </mat-panel-title>
          <mat-panel-description>
            Software
            <mat-icon>widgets</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <button
            mat-raised-button
            color="primary"
            (click)="On3placceso(1)"
            *ngIf="false"
          >
            Parking spaces access
            <mat-icon>phonelink</mat-icon>
          </button>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 0"
        hideToggle
        routerLink="/shipping"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px"
            >Warehouse Shipping</mat-panel-title
          >
          <mat-panel-description>
            <mat-icon style="margin-left: 4vw !important;"
              >local_shipping</mat-icon
            >
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <mat-expansion-panel
        *ngIf="!isLDT"
        [expanded]="step === 1"
        hideToggle
        routerLink="/receive"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px"
            >Receiving Products</mat-panel-title
          >
          <mat-panel-description>
            <mat-icon style="margin-left: 5vw !important;"
              >receipt_long</mat-icon
            >
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        *ngIf="isLDT"
        [expanded]="step === 81"
        hideToggle
        routerLink="/receive-pallets"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px"
            >Receiving Products Pallets</mat-panel-title
          >
          <mat-panel-description>
            <mat-icon style="margin-left: 1vw !important;"
              >receipt_long</mat-icon
            >
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 120"
        hideToggle
        routerLink="/warehouse"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px"
            >Warehouse location</mat-panel-title
          >
          <mat-panel-description>
            <mat-icon style="margin-left: 4vw !important;"
              >local_shipping</mat-icon
            >
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 2"
        hideToggle
        routerLink="/containers"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Containers</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 114px">web</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="step === 3"
        hideToggle
        routerLink="/reports"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Reports</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 135px">poll</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 11"
        hideToggle
        routerLink="/reports-ims"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Reports IMS</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 8.3vw !important">poll</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 4"
        hideToggle
        routerLink="/products"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Products</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 10vw !important;">fastfood</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="step === 5"
        hideToggle
        routerLink="/customers"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Customers</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 115px">group_add</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 6"
        hideToggle
        routerLink="/admin"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Admin</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 11.2vw !important;"
              >phonelink_setup</mat-icon
            >
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 39"
        hideToggle
        routerLink="/invoice"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Invoice</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 11.2vw !important;"
              >description</mat-icon
            >
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 7"
        hideToggle
        routerLink="/appareance"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Appearance </mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 106px">widgets</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="step === 9"
        (opened)="setStep(9)"
        hideToggle
        routerLink="/chat-portal"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px"
            >Chat Support</mat-panel-title
          >
          <mat-panel-description>
            <mat-icon style="margin-left: 96px">chat</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      
      <mat-expansion-panel
        [expanded]="step === 11"
        (opened)="setStep(11)"
        hideToggle
        routerLink="/inventory"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px"
            >Inventory</mat-panel-title
          >
          <mat-panel-description>
            <mat-icon style="margin-left: 96px">fastfood</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 9"
        (click)="OnSalir()"
        hideToggle
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Log Out</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 10vw !important;">login</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    style="top: 70px; padding-left: 0px; padding-right: 0px"
    *ngIf="Customer"
  >
    <mat-accordion class="example-headers-align">
      <mat-expansion-panel
        [expanded]="step === 0"
        hideToggle
        routerLink="/client"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>WAREHOUSE SHIPPING</mat-panel-title>
          <mat-panel-description>
            <mat-icon>local_shipping</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 29"
        hideToggle
        routerLink="/containers-client"
        routerLinkActive="active"
        *ngIf="false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title style="font-size: 17px">Containers</mat-panel-title>
          <mat-panel-description>
            <mat-icon style="margin-left: 114px">web</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
      [expanded]="step === 3"
      hideToggle
      routerLink="/reports"
      routerLinkActive="active"
    >
      <mat-expansion-panel-header>
        <mat-panel-title style="font-size: 17px">Reports</mat-panel-title>
        <mat-panel-description>
          <mat-icon style="margin-left: 135px">poll</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 9"
        (click)="OnSalir()"
        hideToggle
      >
        <mat-expansion-panel-header>
          <mat-panel-title>LOG OUT</mat-panel-title>
          <mat-panel-description>
            <mat-icon>login</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    style="top: 70px; padding-left: 0px; padding-right: 0px"
    *ngIf="Werehouse"
  >
    <mat-accordion class="example-headers-align">
      <mat-expansion-panel
        [expanded]="step === 0"
        hideToggle
        routerLink="/shiptorder"
        routerLinkActive="active"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Search Orders</mat-panel-title>
          <mat-panel-description>
            <mat-icon>local_shipping</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel
        [expanded]="step === 9"
        (click)="OnSalir()"
        hideToggle
      >
        <mat-expansion-panel-header>
          <mat-panel-title>LOG OUT</mat-panel-title>
          <mat-panel-description>
            <mat-icon>login</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</aside>
